module.exports = __webpack_public_path__ + "static/media/wardah.e13ae83a.png";